module.exports = __webpack_public_path__ + "img/punyshort.eb675a38.png";